// eslint-disable-next-line import/prefer-default-export
export const getRandom = (array) =>
  array[Math.floor(Math.random() * array.length)];
